import { Ionicons } from '@expo/vector-icons'
import { useHeaderHeight } from '@react-navigation/stack'
import { Box, Icon, Input, VStack, HStack, Text } from 'native-base'
import React from 'react'
import {
    Dimensions, FlatList, TouchableOpacity
} from 'react-native'
import moment from 'moment'

export default function OrderList(props) {
    const { t, orders } = props
    const headerHeight = useHeaderHeight();

    const renderOrdersView = (object) => {
        const { item } = object
        const { _id, orderId, products, reservations, price, createdAt, status } = item
        let totalProducts = 0
        let totalReservations = 0
        totalProducts = products.reduce((acc, f) => { return acc + f.quantity }, 0)
        totalReservations = reservations.reduce((acc, f) => { return acc + f.quantity }, 0)
        return (
            <TouchableOpacity onPress={() => props.onOrderPress(_id)}>
                <VStack w={'100%'} p={2}>
                    <HStack w={'100%'} justifyContent={'space-between'} >
                        <Text p={2} fontSize={'xs'}>{t('orderNumber', { orderId: orderId })}</Text>
                        <Text p={2} fontSize={'xs'}>{t(status)}</Text>
                    </HStack>
                    <Text p={2} fontSize={'xs'}>{t('orderCreatedAt', { date: moment(createdAt).format('YYYY-MM-DD') })}</Text>
                    <Text p={2} fontSize={'xs'}>{t('orderSummary', { totalProducts: totalProducts, totalReservations: totalReservations, price: price.toFixed(1) })}</Text>
                </VStack>
            </TouchableOpacity>
        )
    }


    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <VStack px={6} py={2} space={2}>
                <Input
                    placeholder="Search"
                    variant="filled"
                    width="100%"
                    bg="gray.200"
                    borderRadius={10}
                    py={1}
                    px={2}
                    keyboardType={'number-pad'}
                    _web={{
                        _focus: { borderColor: 'muted.300', style: { boxShadow: 'none' } },
                    }}
                    InputLeftElement={<Icon size='sm' ml={2} size={5} color="gray.400" as={<Ionicons name="ios-search" />} />}
                    onChangeText={(v) => props.onChangeText(v)}
                />
            </VStack>
            <FlatList
                ItemSeparatorComponent={() => {
                    return (
                        <Box
                            borderBottomWidth={1}
                            borderBottomColor={'gray.200'}
                        />
                    )
                }}
                style={{ backgroundColor: 'white' }}
                onEndReached={() => props.onEndReached()}
                data={orders}
                renderItem={(object) => renderOrdersView(object)}
                keyExtractor={(item, index) => index.toString()}
            />
        </Box>
    )
}